export default __webpack_public_path__ + "static/media/clock.786b0125.svg";